.chart-overlay-wrapper
  .chart-wrapper
    div(data-hook="chart").ct-chart.transactions-chart
  if (!transactions.length)
    .chart-empty-overlay Leider sind noch keine Transaktionen vorhanden.
